import CustomButton from 'components/buttons/CustomButton'
import React, { useEffect, useState } from 'react'
import FontAwesome from 'react-fontawesome'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { fetchTypesSuccess } from 'store/actions/resourceActions'
import I18n from '../../resources/i18n/I18n'
import TypeApi from '../../services/typeApi'
import LabelEditionTree from './LabelEditionTree'

const CategoryEdition = () => {
  const [error, setError] = useState(null)
  const dispatch = useDispatch()
  const history = useHistory()
  const types = useSelector((state) => state.resourceReducer.types)

  useEffect(() => {
    if (types.length === 0) {
      getTypes()
    }
  }, [types])

  const goBack = () => {
    history.push('/configuration')
  }

  const getTypes = () => {
    TypeApi.getTypeList().then((response) => dispatch(fetchTypesSuccess(response)))
  }

  const deleteCategory = (category) => {
    setError(null)
    TypeApi.deleteCategory(category.id)
      .then(() => getTypes())
      .catch(() => setError(I18n.t('ErrorDelete')))
  }

  const editCategory = (category) => {
    TypeApi.editCategory(category).then(() => getTypes())
  }

  const createCategory = (item) => {
    TypeApi.addCategory(item.idParent, { label: item.label }).then(() => getTypes())
  }

  const tree = []
  // Build the model to make it compatible with the LabelEditionTree component
  types.forEach((item) => {
    item.subtypes.forEach((s) => {
      const subtype = { ...s, subtypes: s.categories }
      tree.push(subtype)
    })
  })

  return (
    <div className="container-fluid">
      <LabelEditionTree items={tree} deleteLabel={deleteCategory} editLabel={editCategory} createLabel={createCategory} error={error} />
      <div className="row justify-content-center p-4">
        <CustomButton onClick={goBack} icon={<FontAwesome name="arrow-left" />} small secondary />
      </div>
    </div>
  )
}

export default CategoryEdition
